/**
 * PHForms - envio de formularios de PadelHouse sin recargar (e-Growth).
 * 2026-08-20.
 *
 * LO QUE HAY QUE SABER ANTES DE TOCAR NADA
 *
 * Enviar a /contact necesita DOS cosas a la vez. Falta una y Shopify contesta
 * 403 "Verifying your connection..." (comprobado con un POST directo desde consola
 * el 2026-08-20):
 *
 *   1) Que el formulario sea NATIVO, de los que pinta Liquid con {% form %}.
 *   2) Que ese formulario este PROTEGIDO, o sea que el script de Shopify le haya
 *      metido el `form_key` y el token del captcha. OJO: el form_key NO viene en el
 *      HTML. Se lo inyecta captcha-bootstrap cuando alguien enfoca un campo... y si
 *      nadie lo enfoca, hay que pedirselo a mano con Shopify.captcha.protect().
 *
 * Eso explica todo lo que veniamos viendo:
 *   - El popup y el minijuego entran porque el cliente ESCRIBE en su campo: ese focus
 *     dispara el bootstrap y el formulario sale protegido.
 *   - El test y PHCapture no habian capturado un email en su vida: montaban el
 *     formulario a mano, sin nativo y sin proteger.
 *   - Y un formulario nativo pero oculto, al que nadie enfoca, tampoco vale por si
 *     solo. Le falta el paso 2.
 *
 * DE AHI SALE ESTE ARCHIVO. Un unico camino para todo:
 *   captcha.protect() -> submit de verdad -> a un iframe invisible (para que la
 *   pagina no se mueva) -> se lee la URL de vuelta, que solo trae *_posted=true
 *   cuando Shopify lo ha aceptado.
 *
 *   a) Formularios propios del tema (newsletter del footer, contacto jugador,
 *      contacto B2B): se enganchan solos y encienden su acuse ahi mismo.
 *   b) Formulario DONANTE: un {% form %} vacio y oculto que ph-footer.liquid pinta en
 *      todas las paginas, para los modulos que no tienen formulario propio (el test,
 *      el buscador, favoritos, el 404).
 *   c) Puente de fetch: el codigo antiguo que hace fetch('/contact') se reencamina al
 *      donante sin tener que reescribirlo.
 *
 * Contrato del markup para (a):
 *   <form data-ph-async>            <- o una clase/id de los de CONOCIDOS
 *     <div data-ph-fields>...</div>   campos; se ocultan al terminar (opcional)
 *     <p data-ph-ok hidden>...</p>    confirmacion (opcional)
 *     <p data-ph-error hidden>...</p> error (opcional)
 *   </form>
 * Y data-ph-keep en el <form> para NO ocultar los campos al terminar.
 */
(function () {
  'use strict';
  if (window.PHForms) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/').replace(/\/$/, '');
  var CONTACTO = ROOT + '/contact';
  // Destino minusculo a proposito: sin return_to el iframe cargaria la pagina entera y
  // volveria a ejecutar dentro analitica, pixeles y popups.
  var VUELTA = ROOT + '/cart.js';
  var ESPERA_CAPTCHA = 8000;
  var ESPERA_RESPUESTA = 20000;
  var OCULTO = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;border:0;overflow:hidden';
  var contador = 0;

  /* ---------------------------------------------------------------------
     Paso 2: pedirle a Shopify que proteja el formulario.
     --------------------------------------------------------------------- */
  function protegido(form) {
    return new Promise(function (listo) {
      var captcha = window.Shopify && window.Shopify.captcha;
      if (!captcha || typeof captcha.protect !== 'function') return listo();
      var hecho = false;
      var seguir = function () {
        if (hecho) return;
        hecho = true;
        listo();
      };
      try {
        captcha.protect(form, seguir);
      } catch (e) {
        return seguir();
      }
      // Si el captcha no contesta, se envia igual: mejor intentarlo que quedarse
      // colgado esperando para siempre.
      setTimeout(seguir, ESPERA_CAPTCHA);
    });
  }

  /* ---------------------------------------------------------------------
     El nucleo. Manda un formulario nativo de verdad, pero a un iframe.

     Se dispara un submit REAL (clic en su boton), no form.submit(), porque
     form.submit() no lanza el evento y entonces ni el captcha ni el bootstrap de
     Shopify se enteran. Ese segundo submit vuelve a pasar por onSubmit, que lo
     deja correr al ver la marca data-ph-lanzando.
     --------------------------------------------------------------------- */
  function enviarNativo(form) {
    return new Promise(function (resolve, reject) {
      contador += 1;
      var nombre = 'ph-forms-' + contador;

      var iframe = document.createElement('iframe');
      iframe.name = nombre;
      iframe.title = 'Envio de formulario';
      iframe.setAttribute('aria-hidden', 'true');
      iframe.setAttribute('tabindex', '-1');
      iframe.style.cssText = OCULTO;
      document.body.appendChild(iframe);

      var targetPrevio = form.getAttribute('target');
      var vuelta = form.querySelector('input[name="return_to"]');
      var vueltaPuesta = false;
      if (!vuelta) {
        vuelta = document.createElement('input');
        vuelta.type = 'hidden';
        vuelta.name = 'return_to';
        vuelta.value = VUELTA;
        form.appendChild(vuelta);
        vueltaPuesta = true;
      }

      // Si el formulario no tiene boton propio se le pone uno temporal: hace falta un
      // clic de verdad para que salga un submit de verdad.
      var boton = form.querySelector('button[type="submit"], input[type="submit"]');
      var botonPuesto = false;
      if (!boton) {
        boton = document.createElement('button');
        boton.type = 'submit';
        boton.tabIndex = -1;
        boton.style.cssText = OCULTO;
        form.appendChild(boton);
        botonPuesto = true;
      }

      var cerrado = false;
      var reloj;

      function limpiar() {
        form.removeAttribute('data-ph-lanzando');
        if (targetPrevio === null) form.removeAttribute('target');
        else form.setAttribute('target', targetPrevio);
        if (vueltaPuesta && vuelta.parentNode) vuelta.parentNode.removeChild(vuelta);
        if (botonPuesto && boton.parentNode) boton.parentNode.removeChild(boton);
        setTimeout(function () {
          if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        }, 0);
      }

      function cerrar(error) {
        if (cerrado) return;
        cerrado = true;
        clearTimeout(reloj);
        limpiar();
        if (error) reject(error);
        else resolve();
      }

      iframe.addEventListener('load', function () {
        var url;
        try {
          url = iframe.contentWindow.location.href;
        } catch (e) {
          // Si deja de ser mismo origen no se puede leer el resultado. Antes que mentir
          // con un "listo", se da por fallido.
          return cerrar(new Error('envio-ilegible'));
        }
        if (!url || url === 'about:blank') return;
        // Shopify SOLO anade *_posted=true cuando ha aceptado. Su pagina de challenge
        // ("Verifying your connection...") tambien carga aqui: es un fallo.
        if (url.indexOf('_posted=true') !== -1) return cerrar();
        var titulo = '';
        try {
          titulo = (iframe.contentDocument && iframe.contentDocument.title) || '';
        } catch (e) {}
        var motivo = titulo.replace(/\s+/g, ' ').trim().slice(0, 60) || 'rechazado';
        console.error('[PHForms] Shopify ha rechazado el envio. Motivo:', motivo, '| URL de vuelta:', url, form);
        cerrar(new Error('envio-' + motivo));
      });

      reloj = setTimeout(function () {
        console.error('[PHForms] Shopify no ha contestado en 20 s.', form);
        cerrar(new Error('envio-sin-respuesta'));
      }, ESPERA_RESPUESTA);

      protegido(form).then(function () {
        if (cerrado) return;
        form.setAttribute('data-ph-lanzando', '');
        form.setAttribute('target', nombre);
        boton.click();
      });
    });
  }

  /* ---------------------------------------------------------------------
     Formulario donante
     --------------------------------------------------------------------- */
  // El form_key es de UN SOLO USO. En cuanto un formulario se envia, ese mismo
  // formulario ya no vale para un segundo envio: Shopify lo rechaza (por eso el
  // newsletter del footer se sella al terminar). Con el donante eso significaba que
  // solo entraba la PRIMERA captura de cada carga de pagina: el buscador, el test,
  // favoritos y el 404 fallaban a partir de la segunda, y quien lo reintentaba veia
  // un error por hacerlo bien dos veces.
  //
  // Solucion: se guarda una copia VIRGEN del donante -antes de que el captcha lo
  // firme- y se repone despues de cada envio. El siguiente arranca con un formulario
  // nuevo, sin estrenar, que Shopify vuelve a firmar.
  var virgenes = {};
  var FIRMAS = 'input[name="form_key"], input[name="g-recaptcha-response"], input[name="h-captcha-response"]';

  function donante(tipo) {
    var form = document.getElementById('ph-donante-' + tipo);
    if (!form) return null;
    if (!virgenes[tipo]) {
      var copia = form.cloneNode(true);
      // Por si la copia se toma tarde: una plantilla virgen no puede llevar la firma
      // de un envio anterior.
      Array.prototype.slice.call(copia.querySelectorAll(FIRMAS)).forEach(function (el) {
        el.parentNode.removeChild(el);
      });
      virgenes[tipo] = copia;
    }
    return form;
  }

  function reponer(tipo, form) {
    var virgen = virgenes[tipo];
    if (!virgen || !form || !form.parentNode) return;
    form.parentNode.replaceChild(virgen.cloneNode(true), form);
  }

  function porDonante(datos) {
    var tipo = String(datos.form_type || 'customer') === 'contact' ? 'contact' : 'customer';
    var form = donante(tipo);
    if (!form) return Promise.reject(new Error('envio-sin-donante'));
    // Se reutiliza el mismo formulario en cada envio, asi que no puede haber dos a la
    // vez: el segundo pisaria los campos del primero.
    if (form.hasAttribute('data-ph-ocupado')) return Promise.reject(new Error('envio-ocupado'));
    form.setAttribute('data-ph-ocupado', '');

    // Fuera lo que se inyecto la vez anterior, y a cero los campos que ya trae. OJO: no
    // se tocan los que haya metido el captcha (form_key y compania), que no empiezan
    // por contact[.
    Array.prototype.slice.call(form.querySelectorAll('[data-ph-inyectado]')).forEach(function (el) {
      el.parentNode.removeChild(el);
    });
    Array.prototype.slice.call(form.querySelectorAll('input, textarea')).forEach(function (el) {
      if (el.name && el.name.indexOf('contact[') === 0) el.value = '';
    });

    Object.keys(datos).forEach(function (nombre) {
      // form_type, utf8 y form_key ya los pone Liquid o el captcha. Tocarlos es justo
      // lo que rompe el envio.
      if (nombre === 'form_type' || nombre === 'utf8' || nombre === 'form_key') return;
      var campo = form.querySelector('[name="' + nombre + '"]');
      if (!campo) {
        campo = document.createElement('input');
        campo.type = 'hidden';
        campo.name = nombre;
        campo.setAttribute('data-ph-inyectado', '');
        form.appendChild(campo);
      }
      campo.value = datos[nombre];
    });

    var soltar = function () {
      form.removeAttribute('data-ph-ocupado');
      // Gastado. Fuera y uno nuevo en su sitio, listo para la siguiente captura.
      reponer(tipo, form);
    };

    return enviarNativo(form).then(soltar, function (error) {
      soltar();
      throw error;
    });
  }

  /* ---------------------------------------------------------------------
     Formularios propios del tema
     --------------------------------------------------------------------- */

  // El tag {% form %} de Liquid no admite parametros con guiones, asi que a estos no se
  // les puede poner data-ph-async desde la plantilla: se reconocen por lo que si se les
  // puede dar, su clase o su id.
  var CONOCIDOS = '.phf__form, .ph-pw__signup, #phc-jugador, #phc-b2b';

  function coincide(form) {
    if (!form.matches) return false;
    try {
      return form.matches(CONOCIDOS);
    } catch (e) {
      return false;
    }
  }

  // Solo se mueve la pagina si el aviso ha quedado fuera de la vista. En el footer el
  // usuario ya lo esta mirando y un scroll seria un salto injustificado; en un
  // formulario largo (contacto) el acuse esta arriba del todo y hay que llevarlo.
  function alaVista(el) {
    var caja = el.getBoundingClientRect();
    var alto = window.innerHeight || document.documentElement.clientHeight;
    if (caja.top >= 0 && caja.bottom <= alto) return;
    try {
      el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } catch (e) {
      el.scrollIntoView();
    }
  }

  // Los dos avisos son excluyentes. OJO: hay que apagar SIEMPRE el contrario, no solo
  // encender el que toca. Si no, un envio correcto seguido de uno fallido deja los dos
  // encendidos a la vez y el cliente lee "listo" y "no hemos podido" en la misma caja.
  function pinta(form, exito, mensaje) {
    var ok = form.querySelector('[data-ph-ok]');
    var error = form.querySelector('[data-ph-error]');
    var campos = Array.prototype.slice.call(form.querySelectorAll('[data-ph-fields]'));

    if (ok) ok.hidden = true;
    if (error) error.hidden = true;

    if (exito) {
      if (!form.hasAttribute('data-ph-keep')) {
        campos.forEach(function (c) {
          c.hidden = true;
        });
      }
      if (ok) {
        // role=status + aria-live ya lo lleva el markup, asi que el lector de pantalla
        // lo canta solo; el foco no se mueve para no robarselo a quien esta navegando
        // con teclado en otra parte de la pagina.
        ok.hidden = false;
        alaVista(ok);
      }
      form.setAttribute('data-ph-done', '');
      return;
    }

    if (error) {
      // El motivo tecnico se guarda en el atributo, no se le ensena al cliente. Sirve
      // para soporte; el de verdad va a la consola.
      if (mensaje) error.setAttribute('data-ph-detalle', mensaje);
      error.hidden = false;
      alaVista(error);
    }
  }

  // Un formulario ya enviado con exito no se vuelve a enviar. Donde los campos se
  // ocultan (contacto) esto sobra, pero en el footer siguen a la vista: sin esto, el
  // segundo intento choca contra un form_key ya gastado y el cliente ve un error
  // despues de haberlo hecho bien.
  function sellar(form) {
    Array.prototype.slice.call(form.elements).forEach(function (el) {
      el.disabled = true;
    });
  }

  function botones(form) {
    return Array.prototype.slice.call(form.querySelectorAll('button[type="submit"], input[type="submit"]'));
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;
    // Este es el submit que hemos disparado nosotros con el target ya puesto: se deja
    // correr, que es el que llega a Shopify.
    if (form.hasAttribute('data-ph-lanzando')) return;
    if (!form.hasAttribute('data-ph-async') && !coincide(form)) return;
    event.preventDefault();
    if (form.hasAttribute('data-ph-enviando')) return;
    // La validacion nativa (required, type=email) ya ha pasado: el evento submit no se
    // dispara si el formulario no es valido.

    form.setAttribute('data-ph-enviando', '');
    var bloqueados = botones(form).filter(function (b) {
      return !b.disabled;
    });
    bloqueados.forEach(function (b) {
      b.disabled = true;
    });
    // Los botones se sueltan justo antes de lanzar: un boton disabled no dispara el
    // clic con el que se manda el formulario.
    var soltarBotones = function () {
      bloqueados.forEach(function (b) {
        b.disabled = false;
      });
    };
    soltarBotones();

    enviarNativo(form).then(
      function () {
        pinta(form, true);
        form.removeAttribute('data-ph-enviando');
        sellar(form);
      },
      function (error) {
        pinta(form, false, error && error.message);
        form.removeAttribute('data-ph-enviando');
      }
    );
  }

  // En captura, para llegar antes que cualquier listener de seccion.
  document.addEventListener('submit', onSubmit, true);

  /* ---------------------------------------------------------------------
     Puente para el codigo antiguo que llama a fetch('/contact')
     --------------------------------------------------------------------- */

  function esContacto(entrada) {
    var url = '';
    if (typeof entrada === 'string') url = entrada;
    else if (entrada && typeof entrada.url === 'string') url = entrada.url;
    if (!url) return false;
    try {
      url = new URL(url, window.location.origin).pathname;
    } catch (e) {
      /* rutas relativas raras: se compara tal cual */
    }
    return url === CONTACTO || url === '/contact' || /\/contact$/.test(url);
  }

  function respuesta(ok) {
    var url = VUELTA + (ok ? '?customer_posted=true' : '');
    return {
      ok: ok,
      status: ok ? 200 : 422,
      statusText: ok ? 'OK' : 'Unprocessable Entity',
      redirected: true,
      type: 'basic',
      url: url,
      headers: { get: function () { return null; } },
      clone: function () { return respuesta(ok); },
      text: function () { return Promise.resolve(''); },
      json: function () { return Promise.resolve({}); }
    };
  }

  var fetchOriginal = window.fetch;
  if (typeof fetchOriginal === 'function') {
    window.fetch = function (entrada, opciones) {
      var metodo = (opciones && opciones.method) || (entrada && entrada.method) || 'GET';
      var cuerpo = opciones && opciones.body;
      var esPost = String(metodo).toUpperCase() === 'POST';
      var esFormData = typeof FormData !== 'undefined' && cuerpo instanceof FormData;

      if (!esPost || !esFormData || !esContacto(entrada) || !cuerpo.get('form_type')) {
        return fetchOriginal.apply(this, arguments);
      }

      // Con form_key el FormData sale de un formulario que el cliente ha enfocado y que
      // Shopify ya ha protegido: eso funciona tal cual (es el caso del popup y del
      // minijuego) y no se toca.
      if (cuerpo.get('form_key')) {
        return fetchOriginal.apply(this, arguments);
      }

      // Sin form_key Shopify contesta 403. Se reenvia por el donante, que si es nativo
      // y al que si se le pide proteccion.
      var datos = {};
      cuerpo.forEach(function (valor, nombre) {
        if (typeof valor === 'string') datos[nombre] = valor;
      });
      return porDonante(datos).then(
        function () {
          return respuesta(true);
        },
        function () {
          return respuesta(false);
        }
      );
    };
  }

  window.PHForms = {
    enviar: enviarNativo,
    enviarCampos: porDonante
  };
})();
